<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title"><template v-if="auxiliary">{{ auxiliary.name }} -</template> 核算项目余额</span>
    </div>
    <Row type="flex" :space-x="10" class="margin-right-left margin-top">
      <Cell>
        <!--        <account-date-choose v-model="accountDate"/>-->
        <DropdownCustom ref="paramsDropdown" button class="h-btn-primary mr-20px" trigger="click">
          <div v-if="start!==end">{{ fqFormat(start) }} 至 {{ fqFormat(end) }}</div>
          <div v-else>{{ fqFormat(start) }}</div>
          <template #content>
            <Form style="padding: 10px;width: 400px">
              <FormItem class="!pb-5px" label="会计期间">
                <div class="flex items-center">
                  <Select @change="dateCheck" v-model="start" :deletable="false" :datas="checkoutSelect"/>
                  <span class="mx-8px">至</span>
                  <Select @change="dateCheck" v-model="end" :deletable="false" :datas="checkoutSelect"/>
                </div>
              </FormItem>
              <FormItem class="!pb-5px" label="科目">
                <Select :datas="subjectList" :filter="filter" keyName="id" titleName="fullName"
                        v-model="subjectId">
                  <template #show="{value}">
                    {{ value.code }} {{ value.fullName }}
                  </template>
                  <template #item="{item}">
                    {{ item.code }} {{ item.fullName }}
                  </template>
                </Select>
              </FormItem>
              <FormItem class="!pb-5px" label="类别明细">
                <Select :datas="auxiliaryItemList" :filter="filterAux" keyName="id" titleName="name"
                        v-model="itemId">
                  <template #item="{item}">
                    {{ item.name }}
                  </template>
                </Select>
              </FormItem>
              <!-- //格式化数量 AABV-->
            <FormItem class="!pb-5px" label="数量小数">
              <div class="flex items-center">
                <div><Radio v-model="quantityRadio" :datas="quantity" @change="changeQuantityRadio"></Radio></div>
              </div>
            </FormItem>
              <FormItem class="!pb-5px">
                <Button color="primary" @click="loadList();" :loading="loading">确定</Button>
                <Button @click="this.$refs.paramsDropdown.hide()">取消</Button>
                <Button @click="resetForm">重置</Button>
              </FormItem>
            </Form>
          </template>
        </DropdownCustom>
      </Cell>
      <Cell class="label">辅助类别：</Cell>
      <Cell>
        <Select type="object" @change="auxiliaryChange" v-model="auxiliary" :deletable="false" style="min-width: 100px" :datas="auxiliaryType" keyName="id" titleName="name"/>
      </Cell>
      <Cell>
        <Button :disabled="!auxiliary" :loading="loading" color="primary" @click="doSearch">查询</Button>
      </Cell>
      <Cell>
        <div style="margin-top: 10px;margin-left: 20px;">
          <Checkbox @change="showSubjectChange()" v-model="showSubject">显示科目</Checkbox>
        </div>
      </Cell>
      <Cell :flex="1" class="text-right">
        <!-- jxd7.24 -->
        <div class="float-right flex items-center">
          <Checkbox style="height: 32px;line-height:32px;" class="mr-16px" v-model="showYearTotal" :disabled="showYearTotalDis">显示本年累计</Checkbox>
          <Checkbox style="height: 32px;line-height:32px;" class="mr-16px" v-model="showNumPrice">显示数量金额</Checkbox>
          <vxe-button @click="exportData" icon="fa fa-download" content="导出"/>
          <vxe-button @click="printData" icon="fa fa-print" content="打印"/>
        </div>
      </Cell>
    </Row>
    <div class="h-panel-body" v-if="auxiliary">
      <vxe-table ref="xTable" :data="dataList" stripe border>
        <vxe-column :title="`${auxiliary.name}编码`" field="code">
          <template #default="{row}">
            <div :style="{'padding-left':(row.level)*10+'px'}">{{ row.code }}</div>
          </template>
        </vxe-column>
        <vxe-column :title="`${auxiliary.name}名称`" field="name">
          <template #default="{row}">
            <div :style="{'padding-left':(row.level)*10+'px'}">{{ row.name }}</div>
          </template>
        </vxe-column>

        <!-- 普通模式：只显示金额 -->
        <template v-if="!showNumPrice">
          <vxe-colgroup title="期初余额" align="center">
            <vxe-column title="借方" field="beginningDebitBalance" align="right" formatter="toMoney"/>
            <vxe-column title="贷方" field="beginningCreditBalance" align="right" formatter="toMoney"/>
          </vxe-colgroup>
          <vxe-colgroup title="本期发生额" align="center">
            <vxe-column title="借方" field="currentDebitAmount" align="right" formatter="toMoney"/>
            <vxe-column title="贷方" field="currentCreditAmount" align="right" formatter="toMoney"/>
          </vxe-colgroup>
          <!-- jxd7.24 -->
          <vxe-colgroup title="本年发生额" align="center" v-if="showYearTotal">
            <vxe-column title="借方" field="currentYearDebitAmount" align="right" formatter="toMoney"/>
            <vxe-column title="贷方" field="currentYearCreditAmount" align="right" formatter="toMoney"/>
          </vxe-colgroup>
          <vxe-colgroup title="期末余额" align="center">
            <vxe-column title="借方" field="endingDebitBalance" align="right" formatter="toMoney"/>
            <vxe-column title="贷方" field="endingCreditAmount" align="right" formatter="toMoney"/>
          </vxe-colgroup>
        </template>

        <!-- 数量金额模式：显示数量、单价、金额 -->
        <template v-else>
          <vxe-colgroup title="期初余额" align="center">
            <vxe-colgroup title="借方" header-align="center">
              <vxe-column title="数量" field="beginningDebitQuantity" width="80" align="right" :formatter="['toQuantity', quantityRadio]"/>
              <vxe-column title="单价" field="beginningDebitPrice" width="80" align="right" formatter="formatPrice"/>
              <vxe-column title="金额" field="beginningDebitBalance" width="100" align="right" formatter="toMoney"/>
            </vxe-colgroup>
            <vxe-colgroup title="贷方" header-align="center">
              <vxe-column title="数量" field="beginningCreditQuantity" width="80" align="right" :formatter="['toQuantity', quantityRadio]"/>
              <vxe-column title="单价" field="beginningCreditPrice" width="80" align="right" formatter="formatPrice"/>
              <vxe-column title="金额" field="beginningCreditBalance" width="100" align="right" formatter="toMoney"/>
            </vxe-colgroup>
          </vxe-colgroup>

          <vxe-colgroup title="本期发生额" align="center">
            <vxe-colgroup title="借方" header-align="center">
              <vxe-column title="数量" field="currentDebitQuantity" width="80" align="right" :formatter="['toQuantity', quantityRadio]"/>
              <vxe-column title="单价" field="currentDebitPrice" width="80" align="right" formatter="formatPrice"/>
              <vxe-column title="金额" field="currentDebitAmount" width="100" align="right" formatter="toMoney"/>
            </vxe-colgroup>
            <vxe-colgroup title="贷方" header-align="center">
              <vxe-column title="数量" field="currentCreditQuantity" width="80" align="right" :formatter="['toQuantity', quantityRadio]"/>
              <vxe-column title="单价" field="currentCreditPrice" width="80" align="right" formatter="formatPrice"/>
              <vxe-column title="金额" field="currentCreditAmount" width="100" align="right" formatter="toMoney"/>
            </vxe-colgroup>
          </vxe-colgroup>

          <!-- jxd7.24 -->
          <vxe-colgroup title="本年发生额" align="center" v-if="showYearTotal">
            <vxe-colgroup title="借方" header-align="center">
              <vxe-column title="数量" field="currentYearDebitQuantity" width="80" align="right" :formatter="['toQuantity', quantityRadio]"/>
              <vxe-column title="单价" field="currentYearDebitPrice" width="80" align="right" formatter="formatPrice"/>
              <vxe-column title="金额" field="currentYearDebitAmount" width="100" align="right" formatter="toMoney"/>
            </vxe-colgroup>
            <vxe-colgroup title="贷方" header-align="center">
              <vxe-column title="数量" field="currentYearCreditQuantity" width="80" align="right" :formatter="['toQuantity', quantityRadio]"/>
              <vxe-column title="单价" field="currentYearCreditPrice" width="80" align="right" formatter="formatPrice"/>
              <vxe-column title="金额" field="currentYearCreditAmount" width="100" align="right" formatter="toMoney"/>
            </vxe-colgroup>
          </vxe-colgroup>

          <vxe-colgroup title="期末余额" align="center">
            <vxe-colgroup title="借方" header-align="center">
              <vxe-column title="数量" field="endingDebitQuantity" width="80" align="right" :formatter="['toQuantity', quantityRadio]"/>
              <vxe-column title="单价" field="endingDebitPrice" width="80" align="right" formatter="formatPrice"/>
              <vxe-column title="金额" field="endingDebitBalance" width="100" align="right" formatter="toMoney"/>
            </vxe-colgroup>
            <vxe-colgroup title="贷方" header-align="center">
              <vxe-column title="数量" field="endingCreditQuantity" width="80" align="right" :formatter="['toQuantity', quantityRadio]"/>
              <vxe-column title="单价" field="endingCreditPrice" width="80" align="right" formatter="formatPrice"/>
              <vxe-column title="金额" field="endingCreditAmount" width="100" align="right" formatter="toMoney"/>
            </vxe-colgroup>
          </vxe-colgroup>
        </template>
      </vxe-table>
    </div>
  </app-content>
</template>

<script>
import BooUtil from "@/views/accountbook/bookUtil";
import accountbook from "@/api/accountbook";
import {downloadBlob} from "download.js";
import manba from "manba";
import {mapGetters, mapState} from "vuex";
import setting from "@/api/setting";

export default {
  name: "AuxiliaryAccountingBalance",
  data() {
    return {
      showYearTotalDis:false,//jxd7.24
      showYearTotal: false,//jxd7.24
      dataList: [],
      showNumPrice: false,
      quantityRadio: 2,//格式化数量AABV
      quantity: [{ title: '2位', key: 2 },{ title: '4位', key: 4 },{ title: '6位', key: 6 }],//格式化数量AABV
      showSubject: false,
      loading: false,
      accountDate: null,
      start: null,
      end: null,
      subjectId: null,
      auxiliary: null,
      itemId: null,
      auxiliaryItemList: [],
      auxiliaryType: [],
      auxiliaryList: [],
      subjectList: [],
      tablePrint: {
        // 自定义打印的样式示例
        style: `
          /* 整个表格的基础样式 */
          .vxe-table {
            font-family: "Microsoft YaHei", 微软雅黑, "MicrosoftJhengHei", 华文细黑, STHeiti, MingLiu; // 设置表格整体字体
          }

          /* 表头单元格 */
          .vxe-table thead th {
            border: 1px solid #000;
            font-size: 14px;
            word-break: break-all;
            overflow-wrap: break-word;
          }

          /* 表体单元格（即数据行的所有单元格） */
          .vxe-body--column,
          .vxe-table tbody td {
            border: 1px solid #000;
            font-size: 12px;
            word-break: break-all;
            overflow-wrap: break-word;
          }
        `,
        beforePrintMethod: ({ content }) => {
          const headerHtml = `<h3>核算项目总账</h3>
            <div style="display:flex;justify-content: space-between;height:22px;line-height:22px">
                <span>辅助核算类别：${this.auxiliary.name}</span>
                <span> ${this.title} </span>
                <span> 单位：元 </span>
            </div>
          `;
          const footerHtml = `<div style="display:flex;justify-content: left;;height:22px;line-height:22px">编制单位：${this.currentAccountSets.companyName}</div>`;
          return `${headerHtml}${content}${footerHtml}`;
        },
      },
    }
  },
  computed: {
    ...mapState(['currentAccountSets']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
    title() {
      if (!this.start) {
        return '';
      }
      if (this.start === this.end) {
        return manba(this.start).format("YYYY年MM期")
      }
      return manba(this.start).format("YYYY年MM期") + " - " + manba(this.end).format("YYYY年MM期");
    },
  },
  methods: {
    //格式化数量AABV
    changeQuantityRadio(data){
      this.quantityRadio = data.key;
    },
    filter(item, val) {
      return item.code.indexOf(val) !== -1 || item.name.indexOf(val) !== -1 || item.mnemonicCode.indexOf(val) !== -1;
    },
    filterAux(item, val) {
      console.log(item,val)
      return item.code.indexOf(val) !== -1 || item.name.indexOf(val) !== -1 || item.code.indexOf(val) !== -1;
    },
    formatPrice({ cellValue }) {
      if (cellValue === null || cellValue === undefined || cellValue === 0) {
        return '';
      }
      return Number(cellValue).toFixed(2);
    },
    resetForm(){
      this.itemId = null
      this.subjectId = null
    },
    dateCheck(){
      // 定义开始时间和结束时间
      let startDate = new Date(this.start);
      let endDate = new Date(this.end);
      if(startDate > endDate){
        this.$Message({
          type:'warn',
          text: `开始时间必须早于或等于结束时间！`
        });
      }
      //jxd跨年强制不允许查看本年累计
      if(manba(this.start).year() != manba(this.end).year()){
        this.showYearTotalDis = true;this.showYearTotal = false;
      }else{
        this.showYearTotalDis = false;
      }
    },
    //jxd解决异步showSubject值没有得到最新的
    showSubjectChange(){
      this.$nextTick(() => {
        this.loadList();
      });
    },
    loadAuxiliaryType() {
      this.$api.setting.accountingCategory.list().then(({data}) => {
        this.auxiliaryType = data;
        if (data.length) {
          this.auxiliary = data[0];
          this.loadAuxiliaryItems(this.auxiliary)
          this.loadList();
        }
      });
    },
    loadAuxiliaryItems(auxiliary) {
      accountbook.loadAuxiliary({categoryId:auxiliary.id,categoryType:auxiliary.categoryType}).then(({data}) => {
        data.forEach(val => val.name = val.code + " " + val.name);
        data = data.sort((a, b) => a.code.localeCompare(b.code));
        this.$nextTick(()=>{
          this.auxiliaryItemList = data;
          this.loadList();
        })
      });
    },
    auxiliaryChange(){
      this.loadAuxiliaryItems(this.auxiliary)
      this.itemId = null;
    },
    loadList() {
      if (this.auxiliary) {
        this.loading = true;
        this.$api.accountbook.loadAuxiliaryBalance({
          accountDate: this.accountDate,
          auxiliaryId: this.auxiliary.id,
          itemId: this.itemId,
          showSubject: this.showSubject,
          subjectId: this.subjectId,
          start: this.start,
          end: this.end,
        }).then(({data}) => {
          // data = data.sort((a, b) => Number(a.code) - Number(b.code));//jxd 按数值排序
          this.dataList = data;
        }).finally(() => {
          this.loading = false;
        });
      }
      this.$refs.paramsDropdown.hide()
    },
    doSearch() {
      this.loadList();
    },
    exportData() {
      const utils = new BooUtil(this.$refs.xTable, '\n')
      accountbook.download({header: utils.header, dataList: utils.dataList}).then((data) => {
        downloadBlob(`${this.auxiliary ? this.auxiliary.name + '-' : ''}${manba(this.accountDate).format("YYYY年MM期")}-核算项目余额.xls`, data)
      })
    },
    printData() {
      // 获取VXE-Table实例
      const xTable = this.$refs.xTable;
      // 调用打印方法，并传入打印配置
      xTable.print({
        ...this.tablePrint,
      });
    },
  },
  mounted() {
    this.start = manba(this.currentAccountSets.currentAccountDate).format("YYYY-M");
    this.end = this.start;
    this.loadAuxiliaryType();
    // setting.subject.voucherSelect({all: true}).then(({data}) => {
    //   this.subjectList = data;
    // })
    //jxd这里的科目选择应该是所有科目
    setting.subject.listAll().then(({data}) => {
      this.subjectList = data;
    })
  }
}
</script>

<style scoped lang="less">
.balance {
  width: 100%;
  border-collapse: collapse;

  td {
    padding: 0 8px;
    border: 1px solid #e2e2e2;
    font-size: 12px;
    height: 35px;

    &.tip {
      background-color: #FFEEEF;
    }
  }

  tbody tr:nth-child(even) {
    background-color: #f8fbf8;
  }

  tbody tr:hover {
    background-color: #F0F6FF;
  }

  .header {
    td {
      background-color: #F5F5F5;
      text-align: center;
      font-weight: bold;
    }
  }
}
</style>